import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import SubMenu from "antd/lib/menu/SubMenu";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import ChangePassword from "../../components/ChangePassword";

import "../Auth.css";

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { user } = useSelector(({ auth }) => auth);

  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState("");

  useEffect(() => {
    setSelectedKeys(pathname?.slice(1));
  }, [pathname]);

  const getNoHeaderClass = () => {
    return [
      NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
      NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
    ].includes(navStyle)
      ? "gx-no-header-notifications"
      : "";
  };

  const shouldHideMenu = (menu) => {
    if (!menu.isActive) return true;
    
    switch (menu.tabUrl) {
      case "operator-account":
        return !user.account?.read;

      case "deposit-rollback":
        return !user.rollBackDeposit;

      case "deposit-auto-queue":
      case "deposit-verification-queue":
        return !user.operatorAccess?.deposit?.read;

      default:
        return false;
    }
  };


  const linkStyle = (tabUrl) => ({
    color: selectedKeys === tabUrl ? "#fa8c15" : "inherit",
  });

  const renderMenuItem = (menu, isChild = false) => {
    if (shouldHideMenu(menu)) return null;

    return (
      <Menu.Item
        key={menu._id}
        style={{
          textTransform: "capitalize",
          ...(isChild && {
            width: "350px",
            marginLeft: "-20px",
          }),
        }}
      >
        <Link
          to={menu.hasView ? `/${menu.tabUrl}` : "/erropage"}
          style={linkStyle(menu.tabUrl)}
        >
          <i className="icon icon-user" />
          <span>{menu.displayName}</span>
        </Link>
      </Menu.Item>
    );
  };

  const renderSubMenu = (menu) => {
    const children = menu.children
      ?.filter((child) => !shouldHideMenu(child))
      .map((child) => renderMenuItem(child, true));

    if (!children?.length) return null;

    return (
      <SubMenu
        key={menu._id}
        title={
          <Link to="#" onClick={(e) => e.preventDefault()}>
            <span>
              <i className="icon icon-user" />
              <span>{menu.displayName}</span>
            </span>
          </Link>
        }
      >
        {children}
      </SubMenu>
    );
  };

  return (
    <>
      <ChangePassword
        visibleModal={visibleModal}
        setVisibleModal={setVisibleModal}
      />

      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />

      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass()}`}>
          <UserProfile
            selectedKeys={selectedKeys}
            setSelectedKeys={setSelectedKeys}
          />
        </div>

        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            mode="inline"
            defaultOpenKeys={[selectedKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            style={{ textTransform: "capitalize" }}
          >
            {(user?.userType === "vendor" || user?.userType === "operator") &&
              user?.roleDetails?.map((menu) =>
                menu.children?.length
                  ? renderSubMenu(menu)
                  : renderMenuItem(menu),
              )}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);